export default __webpack_public_path__ + "static/media/Tasset of the Triumphant.2d9a7d19.jpg";